<template>
  <div class="grm-avatar-form-component" :class="icon">
    <div class="grm-avatar-form">
      <div class="grm-avatar-wrapper">
        <lazy-component
          class="grm-avatar-lazy"
          :key="userProfileUrl"
        >
          <img
            :src="userProfileUrl"
            :style="{ visibility: userProfileUrl ? 'visible' : 'hidden' }"
            class="grm-avatar"
            alt="profile"
            @error="userProfileUrl = ''"
          >
        </lazy-component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrmAvatar',
  props: {
    icon: String,
    src: String,
  },
  data() {
    return {
      userProfileUrl: ''
    }
  },
  created() {
    if (this.src) {
      this.userProfileUrl = this.src
    }
  }
}
</script>

<style lang="scss" scoped>
.grm-avatar-form-component {
  &.whisper {
    .grm-avatar-form {
      background: #f7683c url('~@/assets/images/whisper_white.svg') no-repeat center / 14px auto;
    }
  }
  &.staff {
    .grm-avatar-form {
      background: #777df6 url('~@/assets/images/whisper_white.svg') no-repeat center / 14px auto;
    }
  }
  &.notice {
    .grm-avatar-form {
      background: $mainColor url('~@/assets/images/notice_white.svg') no-repeat center / 14px auto;
    }
  }
  &.record {
    .grm-avatar-form {
      background: $mainColor url('~@/assets/images/cam_line_white.svg') no-repeat center / 14px auto;
    }
  }
}
.grm-avatar-form {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e5e5e5 url('~@/assets/images/profile.svg') no-repeat center / 12px auto;
  overflow: hidden;
}
.grm-avatar-lazy {}
.grm-avatar {}
</style>